module.exports = __webpack_public_path__ + "media/flags/cat-fad6f647.png";